var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _, { cloneDeep } from 'lodash';
import moment from 'moment';
import { UrlHelper } from '../../helper/UrlWrapper';
import ClientService from '../../api/ClientService';
import AddDialog from './AddDialog.vue';
import GlobalVue from "../../globalVue";
import Detail from './Detail.vue';
import EditDialog from './EditDialog.vue';
import GroupDialog from './GroupDialog.vue';
import Settings from './Settings.vue';
import BindGoods from './BindGoods.vue';
import MsgDialog from './MsgDialog.vue';
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import VerifyCodeDialog from "./VerifyCodeDialog.vue";
import UpdateApAccountIdDialog from "./UpdateApAccountIdDialog.vue";
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import CommonService from "../../api/CommonService";
import CompanyService from "../../api/CompanyService";
import SystemSettingsService from '../../api/SystemSettingsService';
import Clickoutside from 'element-ui/src/utils/clickoutside';
import RegexStr from "../../common/RegexStr";
import RouteManageDialog from "./components/RouteManageDialog.vue";
Vue.directive('click-outside', Clickoutside);
var transactionTimeObj = {
    1: ['', ''],
    2: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    3: [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    4: [moment().subtract(90, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    5: [moment().subtract(180, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    6: [moment().subtract(365, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
};
var phoneRegex = new RegExp(RegexStr.phone);
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.phoneRegex = phoneRegex;
        _this.tableHeight = 300;
        _this.total = 0;
        _this.listData = [];
        _this.clientStatus = [
            { label: '全部', value: '0' },
            { label: '已合作', value: '1' },
            { label: '已暂停', value: '2' },
            { label: '已结束', value: '3' }
        ];
        _this.transactionStatus = [
            { label: '全部', value: 0 },
            { label: '已交易', value: 1 },
            { label: '交易中', value: 2 },
            { label: '未交易', value: 3 }
        ];
        _this.transactionTimeList = [
            { label: '全部', value: 1 },
            { label: '近一周', value: 2 },
            { label: '近一个月', value: 3 },
            { label: '近三个月', value: 4 },
            { label: '近半年', value: 5 },
            { label: '近一年', value: 6 },
        ];
        _this.transactionTimeValue = 1;
        _this.groups = [];
        _this.formData = {
            text: '',
            join_status: '1',
            group: 0,
            from_system: '-1',
            transaction_status: 0,
            franchisee_status: '',
            remain_day: '',
            business_level: '',
            accountdatetype: '',
            ap_account_id: 0,
        };
        _this.importSuccessBusinessNum = 0;
        _this.importSuccessShopNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.dialogTableVisible = false;
        _this.customerFromList = [];
        _this.isMoreSearch = false;
        _this.isDataReady = false;
        _this.joinStatus = [
            {
                id: 0,
                name: '全部'
            },
            {
                id: 1,
                name: '非加盟客户'
            },
            {
                id: 2,
                name: '已加盟'
            },
            {
                id: 3,
                name: '已到期'
            },
        ];
        _this.joinOpen = false;
        _this.businessid = '';
        _this.clientLevel = [];
        _this.activeEditField = '';
        _this.activeRow = {
            franchisee_time: ''
        };
        _this.editFields = ['accountdatetype_name', 'business_phone', 'business_cooperation_state', 'transaction_status_name', 'franchisee_name', 'franchisee_time'];
        _this.settlementList = [];
        _this.isOpenApAccountTypeBusiness = false;
        _this.isOpenShippingFee = false;
        _this.saleUser = [];
        _this.hasBusinessCan = false;
        _this.accountPerformancePower = false;
        _this.systemSetting = '';
        return _this;
    }
    List.prototype.editField = function (row, field) {
        if (row.from_system === 1 && ['accountdatetype_name', 'business_cooperation_state'].includes(field)) {
            return this.$message.warning('供应链客户不可编辑结算方式与合作状态');
        }
        if (field === 'franchisee_time') {
            var value = row.franchisee_stime && row.franchisee_etime ? [row.franchisee_stime, row.franchisee_etime] : '';
            this.$set(row, 'franchisee_time', value);
        }
        row.accountdatetype = row.accountdatetype + '';
        this.activeRow = cloneDeep(row);
        this.activeEditField = field;
        console.log('editField>>>', row);
    };
    List.prototype.handleTimeChange = function (val, row) {
        val = val || [];
        row.franchisee_stime = val[0];
        row.franchisee_etime = val[1];
        console.log('timeChange>>>', val, row);
    };
    List.prototype.saveEditField = function () {
        var _this = this;
        if (!this.activeEditField) {
            return;
        }
        var field = this.activeEditField;
        var row = this.activeRow;
        var params = {
            supplier_to_business_id: row.supplier_to_business_id,
            business_id: row.business_id,
            business_contact: row.business_contact,
            business_phone: row.business_phone,
            business_city_id: row.business_city_id,
            business_address: row.business_address,
            cooperate_stime: row.contract_date && row.contract_date.length > 0 ? row.contract_date[0].format("yyyy-MM-dd") : '',
            cooperate_etime: row.contract_date && row.contract_date.length > 0 ? row.contract_date[1].format("yyyy-MM-dd") : '',
            group_id: row.group_id,
            organ_id: row.organ_id,
            business_name: row.business_name,
            operation_type_ids: (row.operation_type_id || []).join(','),
            accountdatetype: row.accountdatetype,
            accountdateval: row.accountdateval,
            business_cooperation_state: row.business_cooperation_state,
            freeze: row.freeze,
            edi_business_status: row.edi_business_status,
            business_no: row.business_no,
            is_franchisee: row.is_franchisee,
            franchisee_stime: row.franchisee_stime,
            franchisee_etime: row.franchisee_etime,
            business_tel: row.business_tel,
            customer_certificates: row.customer_certificates || [],
            business_level: row.business_level,
            is_validate: 0
        };
        if (field == 'franchisee_name' && row.is_franchisee == 1 && (!row.franchisee_stime || !row.franchisee_etime)) {
            this.$message.error('加盟起止日期不能为空');
            return this.activeEditField = '';
        }
        this.service.editClient(params).then(function (res) {
            console.log('saveEditField>>>', res);
            if (res.data.success) {
                if (res.data.code == 30) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data
                        }
                    }, {
                        title: "提示",
                        width: 450,
                        height: 350,
                        closeBtn: false,
                    }).instance;
                    instance.$on("addClient:ok", function (data) { });
                }
                else {
                    _this.$message.success('保存成功！');
                    if (_this.$refs.rowSelect) {
                        row[field] = _this.$refs.rowSelect.selectedLabel;
                    }
                    var index = _this.listData.findIndex(function (item) { return item.supplier_to_business_id == row.supplier_to_business_id; });
                    if (index > -1) {
                        _this.listData.splice(index, 1, cloneDeep(row));
                    }
                }
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }).catch(function (err) {
            _this.$message.error(err.message);
        }).finally(function () {
            _this.activeEditField = '';
        });
    };
    List.prototype.getSupplierConfigdetail = function () {
        var _this = this;
        this.systemService.getSupplierConfigdetail({}).then(function (res) {
            if (res.data && res.data.success) {
                var data = res.data.data || {};
                _this.systemSetting = data;
                _this.accountPerformancePower = data.account_performance_power == 1 ? true : false;
            }
        });
    };
    List.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 220;
        }, 300);
        if (this.businessid) {
            this.formData.join_status = '0';
        }
        this.service = ClientService.getInstance();
        this.commonService = CommonService.getInstance();
        this.companyService = CompanyService.getInstance();
        this.systemService = SystemSettingsService.getInstance();
        this.getSettlementList();
        this.getJoinConfig();
        this.getClientLevel();
        this.getClientList();
        this.getCustomerFrom();
        this.service.getGroups({ isAll: 1 }).then(function (res) {
            _this.groups = res.data.data || [];
        });
        this.getHasBusinessCan();
        this.getSaleUser();
        this.getSupplierConfigdetail();
    };
    List.prototype.getSaleUser = function () {
        var _this = this;
        this.service.getSaleUser().then(function (res) {
            _this.saleUser = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    List.prototype.getJoinConfig = function () {
        var _this = this;
        this.service.getjoinConfig().then(function (res) {
            if (res.data.data && res.data.data.is_open_franchisee == 1) {
                _this.joinOpen = true;
            }
        }).catch(function (err) {
            _this.$message.error(err.message);
        }).finally(function () {
            _this.isDataReady = true;
        });
    };
    List.prototype.getClientLevel = function () {
        var _this = this;
        this.service.getClientLevel().then(function (res) {
            _this.clientLevel = Array.isArray(res.data.data) ? res.data.data : [];
            _this.clientLevel.unshift({
                id: -1,
                name: '无等级'
            });
        });
    };
    List.prototype.getHasBusinessCan = function () {
        var _this = this;
        this.hasBusinessCan = false;
        this.service.getHasBusinessCan().then(function (res) {
            if (res.data.success) {
                _this.hasBusinessCan = res.data.exists;
            }
            ;
        });
    };
    List.prototype.getClientList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var params = {
            business_name: this.formData.text,
            join_status: this.formData.join_status,
            group_id: this.formData.group,
            from_system: this.formData.from_system,
            transaction_status: this.formData.transaction_status,
            s_time: transactionTimeObj[this.transactionTimeValue][0],
            e_time: transactionTimeObj[this.transactionTimeValue][1],
            franchisee_status: this.formData.franchisee_status,
            business_level: this.formData.business_level,
            ap_account_ids: (this.formData.ap_account_id || []).join(','),
            remain_day: this.formData.remain_day,
            accountdatetype: this.formData.accountdatetype,
            business_ids: this.businessid
        };
        Object.assign(params, pager, {
            sort_field: this.order ? 'business_pinyin' : null,
            sort_type: this.order ? this.order[1] : null
        });
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getClientList(params).then(function (res) {
            if (res.data.success) {
                _this.listData = res.data.data;
                _this.isOpenApAccountTypeBusiness = res.data.is_open_ap_account_type_business;
                _this.isOpenShippingFee = res.data.is_open_shipping_fee;
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
            _this.$nextTick(function () {
                _this.$refs.table && _this.$refs.table.doLayout();
            });
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    List.prototype.getSelectClientIds = function (key) {
        if (key === void 0) { key = 'business_id'; }
        return _.reduce(this.selectRows, function (ori, newItem) {
            return ori += ori ? (',' + newItem[key]) : newItem[key];
        }, '');
    };
    List.prototype.getCustomerFrom = function () {
        var _this = this;
        this.service.getCustomerFrom().then(function (res) {
            if (res.data && res.data.success) {
                (res.data.data || []).unshift({
                    name: '全部来源',
                    value: '-1'
                });
                _this.customerFromList = res.data.data;
            }
        });
    };
    List.prototype.beforeAddClient = function () {
        var _this = this;
        this.service.addCheck().then(function (res) {
            if (res.data.code === 400004) {
                var instance = _this.$dialog(MsgDialog, {
                    data: {
                        msgInfo: __assign({ msg: res.data.msg }, res.data.data)
                    }
                }, {
                    title: "提示",
                    width: 420,
                    height: 250
                }).instance;
            }
            else {
                _this.addClient();
            }
            ;
        }, function (err) {
            _this.$message.error(err.message);
        });
    };
    List.prototype.addClient = function () {
        var _this = this;
        var instance = this.$dialog(AddDialog, {
            data: {
                step: 1,
                joinOpen: this.joinOpen,
                isOpenApAccountTypeBusiness: this.isOpenApAccountTypeBusiness,
                isOpenShippingFee: this.isOpenShippingFee,
            }
        }, {
            title: "添加客户",
            width: 600,
            height: 700
        }).instance;
        instance.$on("addClient:ok", function () {
            _this.getClientList(_this.$refs.pagination.pager);
        });
    };
    List.prototype.lookDetail = function (row) {
        GlobalVue.$emit("addTab", {
            component: Detail,
            title: '客户—' + row.business_name,
            showExist: true,
            name: 'client_' + row.supplier_to_business_id,
            cprops: {
                clientId: row.business_id.toString(),
                supplierToBusinessId: row.supplier_to_business_id.toString()
            }
        });
        window._czc.push(["_trackEvent", '合作客户列表', '查看客户']);
    };
    List.prototype.edit = function (row) {
        var _this = this;
        var instance = this.$dialog(EditDialog, {
            data: {
                row: row,
                joinOpen: this.joinOpen,
                isOpenApAccountTypeBusiness: this.isOpenApAccountTypeBusiness,
                isOpenShippingFee: this.isOpenShippingFee,
            }
        }, {
            title: "编辑客户",
            width: 600,
            height: 700
        }).instance;
        instance.$on("editClient:ok", function () {
            window._czc.push(["_trackEvent", '合作客户列表', '编辑客户']);
            _this.getClientList(_this.$refs.pagination.pager);
        });
    };
    List.prototype.search = function () {
        if (this.formData.remain_day) {
            var reg = /^[1-9]\d*$/;
            if (!reg.test(this.formData.remain_day)) {
                this.$message.error('加盟剩余时长请输入正整数!');
                return;
            }
        }
        this.$refs.pagination.clear();
        this.businessid = '';
        this.getClientList();
    };
    List.prototype.exportdata = function () {
        return __awaiter(this, void 0, void 0, function () {
            var businessIds, supplierToBusinessIds, exportParams, codeRes, exportCode, url, checkRes, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        businessIds = this.selectRows.map(function (item) { return item.business_id; });
                        supplierToBusinessIds = this.selectRows.map(function (item) { return item.supplier_to_business_id; });
                        exportParams = {
                            business_name: this.formData.text,
                            join_status: this.formData.join_status,
                            group_id: this.formData.group,
                            from_system: this.formData.from_system,
                            business_ids: businessIds.join(','),
                            supplier_to_business_ids: supplierToBusinessIds.join(','),
                            transaction_status: this.formData.transaction_status,
                            s_time: transactionTimeObj[this.transactionTimeValue][0],
                            e_time: transactionTimeObj[this.transactionTimeValue][1],
                            franchisee_status: this.formData.franchisee_status,
                            remain_day: this.formData.remain_day,
                            sort_field: this.order ? 'business_pinyin' : null,
                            sort_type: this.order ? this.order[1] : null
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4, this.commonService.paramsToCode({
                                type: 112,
                                data: exportParams
                            })];
                    case 2:
                        codeRes = _a.sent();
                        if (!(codeRes.data.success && codeRes.data.data.code)) return [3, 4];
                        exportCode = codeRes.data.data.code;
                        url = "supplierclientapi/customer/export?export_params_code=" + exportCode;
                        return [4, this.commonService.exportCheck(url)];
                    case 3:
                        checkRes = _a.sent();
                        if (checkRes.data.success) {
                            url = UrlHelper.addParam(url, "token", this.user.token);
                            location.href = url;
                        }
                        return [3, 5];
                    case 4: throw new Error(codeRes.data.msg || '获取导出参数失败');
                    case 5: return [3, 7];
                    case 6:
                        err_1 = _a.sent();
                        this.$message.error(err_1.msg || err_1.message || '导出失败');
                        return [3, 7];
                    case 7: return [2];
                }
            });
        });
    };
    List.prototype.moreSearchComShow = function () {
        this.isMoreSearch = true;
    };
    List.prototype.moreSearchComHide = function () {
        this.isMoreSearch = false;
    };
    List.prototype.pageChange = function (pager) {
        this.getClientList(pager);
    };
    List.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    List.prototype.bindGoods = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择要绑定货品的客户！');
            return;
        }
        if (this.selectRows.length > 1) {
            this.$message.error('暂不支持多选，仅支持对一个客户进行货品关系绑定！');
            return;
        }
        if (this.selectRows[0].from_system != 1) {
            this.$message.error('当前选择客户非供应链客户，暂不支持绑定货品');
            return;
        }
        var ids = this.getSelectClientIds();
        var supplierToBusinessIds = this.getSelectClientIds('supplier_to_business_id');
        GlobalVue.$emit("addTab", {
            component: BindGoods,
            title: '绑定货品',
            showExist: true,
            name: 'bindGoods_' + ids,
            cprops: {
                clientIds: ids,
                business_id: this.selectRows[0].business_id,
                supplierToBusinessIds: supplierToBusinessIds,
                supplier_to_business_id: this.selectRows[0].supplier_to_business_id,
            }
        });
    };
    List.prototype.clientSettings = function (client) {
        var _this = this;
        var instance = this.$dialog(Settings, {
            data: {
                client: client
            }
        }, {
            title: "参数设置",
            width: 700,
            height: 560
        }).instance;
        instance.$on("saveClientParams:ok", function () {
            _this.getClientList(_this.$refs.pagination.pager);
        });
    };
    List.prototype.changeGroup = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择客户！');
            return;
        }
        var groupId = null;
        if (this.selectRows.length === 1) {
            groupId = this.selectRows[0].group_id;
        }
        var instance = this.$dialog(GroupDialog, {
            data: {
                group: groupId,
                clientIds: this.getSelectClientIds('supplier_to_business_id')
            }
        }, {
            title: "将选择客户转移到",
            width: 400,
            height: 160
        }).instance;
        instance.$on("changeGroups:ok", function () {
            _this.getClientList(_this.$refs.pagination.pager);
        });
    };
    List.prototype.deleteCustomer = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择客户！');
            return;
        }
        if (this.selectRows.length > 1) {
            this.$message.error('最多选择一个客户！');
            return;
        }
        this.$confirm('删除后，该客户业务将不可处理，请确认是否继续？', '删除客户提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.service.deleteCustomer({
                    business_id: _this.selectRows[0].business_id,
                    supplier_to_business_id: _this.selectRows[0].supplier_to_business_id,
                }).then(function (res) {
                    if (res.data.success) {
                        if (res.data.code == 30) {
                            var instance = _this.$dialog(ArtMsglist, {
                                data: {
                                    msgData: res.data.data
                                }
                            }, {
                                title: "提示",
                                width: 450,
                                height: 350,
                                closeBtn: false,
                            }).instance;
                            instance.$on("artMsglist:ok", function (data) {
                                var confirm = res.data.data[0].confirm;
                                _this.service.deleteCustomer({
                                    business_id: _this.selectRows[0].business_id,
                                    supplier_to_business_id: _this.selectRows[0].supplier_to_business_id,
                                    confirm: confirm,
                                    sms_code: data.sms_code,
                                }).then(function (res) {
                                    if (res.data.code == 31) {
                                        var instance_1 = _this.$dialog(VerifyCodeDialog, {
                                            data: {
                                                msgData: res.data.data
                                            }
                                        }, {
                                            title: "删除客户提示",
                                            width: 650,
                                            height: 350,
                                            closeBtn: false,
                                        }).instance;
                                        instance_1.$on("artMsglist:ok", function (data) {
                                            _this.service.deleteCustomer({
                                                business_id: _this.selectRows[0].business_id,
                                                supplier_to_business_id: _this.selectRows[0].supplier_to_business_id,
                                                confirm: 1,
                                                sms_code: data,
                                            }).then(function (res) {
                                                if (res.data.success) {
                                                    _this.$message.success('删除成功！');
                                                    instance_1.$closeDialog();
                                                    _this.getClientList();
                                                }
                                            }).catch(function (err) {
                                                _this.$message.error(err.msg || err.message);
                                            });
                                        });
                                    }
                                    else {
                                        _this.$message.success('删除成功！');
                                        _this.getClientList();
                                    }
                                });
                            });
                        }
                        else if (res.data.code == 31) {
                            var instance_2 = _this.$dialog(VerifyCodeDialog, {
                                data: {
                                    msgData: res.data.data
                                }
                            }, {
                                title: "删除客户提示",
                                width: 650,
                                height: 350,
                                closeBtn: false,
                            }).instance;
                            instance_2.$on("artMsglist:ok", function (data) {
                                _this.service.deleteCustomer({
                                    business_id: _this.selectRows[0].business_id,
                                    supplier_to_business_id: _this.selectRows[0].supplier_to_business_id,
                                    confirm: 1,
                                    sms_code: data,
                                }).then(function (res) {
                                    if (res.data.success) {
                                        _this.$message.success('删除成功！');
                                        instance_2.$closeDialog();
                                        _this.getClientList();
                                    }
                                }).catch(function (err) {
                                    _this.$message.error(err.msg || err.message);
                                });
                            });
                        }
                        else {
                            _this.$message.success('删除成功！');
                            _this.getClientList();
                        }
                    }
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        }).catch(function () {
        });
    };
    List.prototype.syncMall = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择客户！');
            return;
        }
        var businessIds = this.selectRows.map(function (item) { return item.business_id; });
        var isNotMall = this.selectRows.filter(function (item) { return item.from_system != 4 && item.from_system != 5; });
        if (isNotMall.length > 0) {
            this.$message.error('只允许“商城来源”或“自主添加且存在商城账号”的客户同步供应门店信息到商城');
            return;
        }
        this.$confirm('是否确定将平台客户供应门店信息同步到商城？', '同步客户供应门店到商城', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.service.syncShopping({
                    business_id: businessIds.join(',')
                }).then(function (res) {
                    if (res.data.success) {
                        _this.$message.success(res.data.msg);
                        _this.getClientList();
                    }
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        }).catch(function () {
        });
    };
    List.prototype.updateApAccountId = function () {
        var _this = this;
        if (!this.isOpenApAccountTypeBusiness) {
            this.$message.error('无法修改客户归属业务员');
            return;
        }
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择客户！');
            return;
        }
        var businessIds = this.selectRows.map(function (item) { return item.business_id; });
        var instance = this.$dialog(UpdateApAccountIdDialog, {
            data: {
                saleUser: this.saleUser,
            }
        }, {
            title: "修改归属业务员",
            width: 400,
            height: 200,
            closeBtn: true,
        }).instance;
        instance.$on("artMsglist:ok", function (data) {
            instance.$closeDialog();
            var param = {
                business_ids: (businessIds || []).join(','),
                account_ids: data,
            };
            _this.service.updateApAccountId(param).then(function (res) {
                if (res.data.success) {
                    _this.$message.success(res.data.msg);
                    _this.getClientList();
                }
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        });
    };
    List.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            if (prop == 'order_status_name') {
                prop = 'order_status';
            }
            this.order = [prop, order === 'ascending' ? 'ASC' : 'DESC'];
        }
        this.getClientList();
    };
    List.prototype.importData = function () {
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    List.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    List.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessBusinessNum = data.success_business_num;
            this.importSuccessShopNum = data.success_shop_num;
            this.importFailnum = data.error_num;
            var url = "/basicapi/export_error?import_id=" + data.import_id + "&type=" + data.type;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.getClientList();
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    List.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    List.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    List.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    List.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    List.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.deleteCustomer();
                break;
            case 2:
                this.importData();
                break;
            case 3:
                this.syncMall();
                break;
            case 4:
                this.updateApAccountId();
                break;
        }
    };
    List.prototype.getSettlementList = function () {
        var _this = this;
        this.companyService.getSettlementList().then(function (res) {
            _this.settlementList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    List.prototype.openRouteManage = function () {
        var instance = this.$dialog(RouteManageDialog, {
            data: {
                clientDetail: []
            }
        }, {
            title: "分拣线路管理",
            width: 800,
            height: 600
        }).instance;
    };
    List = __decorate([
        auth(nameDict["合作客户"], true),
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], List);
    return List;
}(Vue));
export default List;
